// Labels live here, not in the API: the viewer (CRA) cannot import @tournament-suite packages,
// and the API sends only codes, values and thresholds.
export type AchievementCatalogEntry = {
  label: string;
  symbol: string;
  describe: (threshold: number) => string;
  milestone?: boolean;
};

export const ACHIEVEMENT_CATALOG: Record<string, AchievementCatalogEntry> = {
  MARATHON: { label: "Maratończyk", symbol: "🏃", describe: (n) => `${n} rozegranych meczów` },
  REGULAR: { label: "Stały bywalec", symbol: "📅", describe: (n) => `${n} turniejów i kolejek` },
  VETERAN: { label: "Weteran", symbol: "🕰️", describe: (n) => `Mecze w ${n} różnych latach` },
  GIANT_SLAYER: {
    label: "Pogromca faworytów",
    symbol: "🗡️",
    describe: (n) => `Wygrany singiel z rywalem wyżej w rankingu o ${n}+ pkt`,
  },
  COMEBACK: {
    label: "Feniks z popiołów",
    symbol: "🔥",
    describe: (n) => (n === 1 ? "Wygrana po przegranym pierwszym secie" : `${n} wygranych po przegranym pierwszym secie`),
  },
  NAIL_BITER: {
    label: "Na żyletki",
    symbol: "⚡",
    describe: (n) => `${n} ${n === 1 ? "set wygrany" : "setów wygranych"} na przewagach albo o punkt w better point`,
  },
  WIN_STREAK: { label: "Seria", symbol: "📈", describe: (n) => `${n} wygranych z rzędu` },
  DUO: { label: "Zgrany duet", symbol: "🤝", describe: (n) => `${n} różnych partnerów w deblu` },
  DEBUT: { label: "Debiut", symbol: "🏸", describe: () => "Pierwszy rozegrany mecz", milestone: true },
  FIRST_WIN: { label: "Pierwsza wygrana", symbol: "⭐", describe: () => "Pierwszy wygrany mecz", milestone: true },
};

export const LEVEL_NAMES = ["brąz", "srebro", "złoto"];
